import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const navigate = useNavigate();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          个人网站
        </Typography>
        <Box>
          <Button color="inherit" onClick={() => navigate('/')}>首页</Button>
          <Button color="inherit" onClick={() => navigate('/about')}>关于我</Button>
          <Button color="inherit" onClick={() => navigate('/projects')}>项目</Button>
          <Button color="inherit" onClick={() => navigate('/contact')}>联系我</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;